import {
  AppBar,
  Avatar,
  Box,
  Card,
  CardHeader,
  Grid,
  Toolbar,
  Typography,
  IconButton,
  FormControl,
  TextField,
  InputAdornment,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  Divider,
  Checkbox,
  FormControlLabel,
  Stack,
  Slide,
  DialogContentText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useParams } from "react-router-dom";
import React, { useEffect, useState, Fragment, useContext } from "react";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import EditIcon from "@mui/icons-material/Edit";
import { baseUrl } from "../../services/AzureStorage";
import { AppDataContext } from "../../common/appContext";
import { RoutePermissions, RouteScreens } from "../../common/RoutePermissions";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import CircularProgress from "@mui/material/CircularProgress";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import AddIcon from "@mui/icons-material/Add";
import APIURLConstants from "../../common/ApiURLConstants";
import axios from "axios";
import FileSaver from "file-saver";
import Loader from "../../sharedComponents/loader/loader";
import TitleTooltip from "../../sharedComponents/Tooltip/TitleTooltip";

const useStyles = makeStyles((theme) => ({
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  actionIcon: {
    color: "#1d428a",
    cursor: "pointer",
    fontSize: "1.3rem",
  },
  startFill: {
    color: "#dcda33e3",
    cursor: "pointer",
    fontSize: "1.3rem",
  },
  searchTextWidth: {
    maxWidth: "160px",
    textOverflow: "ellipsis",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "200px",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "200px",
    },
  },
  alphabetStyle: {
    color: "#989898",
    paddingRight: "12px",
    cursor: "pointer",
    "&:hover": {
      color: "#1d428a",
      fontWeight: "600",
    },
    "&.selected": {
      color: "#1d428a",
      fontWeight: "600",
    },
  },
  headerGridContainerStyle: {
    [theme.breakpoints.down("lg")]: {
      marginTop: "5px",
    },
  },
  playerCardHeaderCheckBox: {
    padding: "2px",
  },
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
  },
}));

let gridData = [];

export default function PlayerList() {
  const [playerData, setPlayerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [playerNameSearchText, setPlayerNameSearchText] = useState("");
  const { user, selectedEventId } = useContext(AppDataContext);
  let userAppRoles = user.appRoles || [];
  const [eventId, setEventId] = useState(selectedEventId);
  const [favPlayer, setFavPlayer] = useState({
    EventId: eventId,
    UserName: user.loginID,
    playerIds: [],
    Id: 0,
  });
  const [favPlayerIds, setFavPlayerIds] = useState([]);

  const [openAddPlayerModal, setOpenAddPlayerModal] = useState(false);
  const [playerFName, setPlayerFName] = useState("");
  const [playerLName, setPlayerLName] = useState("");
  const [playerCollgeOrClub, setPlayeCollgeOrClub] = useState("");
  const [eventFNameError, setEventFNameError] = useState(false);
  const [eventLNameError, setEventLNameError] = useState(false);
  const [eventCollgeOrClubError, setEventCollgeOrClubError] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("warning");
  const [alertMessage, setAlertMessage] = useState("");

  //... Export to excel player profile.
  const [exportPlayersDetails, setExportPlayersDetails] = useState([]);
  const [overlayLoading, setOverlayLoading] = useState(false);

  const classes = useStyles();
  let navigate = useNavigate();

  const asciiCodes = Array.from(Array(26)).map((e, i) => i + 65);

  const alphabets = asciiCodes.map((x) => String.fromCharCode(x));

  useEffect(() => {
    setEventId(selectedEventId);
  }, [selectedEventId]);

  useEffect(() => {
    if (eventId && Object.keys(user).length) {
      GetFavPlayersByUserNameAndEventId();
    }
    if (eventId) {
      getPlayerData();
    }
  }, [eventId, user]);

  const getPlayerData = () => {
    setLoading(true);
    PlayerProfileService.getPlayerListPageByEventIdYear(
      eventId,
      user?.loginID
    ).then((response) => {
      gridData = [...response.data];
      setPlayerData(response.data);
      setLoading(false);
    });
  };

  const GetFavPlayersByUserNameAndEventId = () => {
    setLoading(true);
    try {
      PlayerProfileService.getFavPlayersByUserNameAndEventId(
        eventId,
        user.loginID
      ).then((response) => {
        if (response != null && response.data.length > 0) {
          setFavPlayer({ ...response.data[0] });
        } else {
          setFavPlayer({
            EventId: eventId,
            UserName: user.loginID,
            PlayerIds: [],
            Id: 0,
          });
        }
        setLoading(false);
      });
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (favPlayer && favPlayer.playerIds && favPlayer.playerIds != "") {
      let arrPlayer = favPlayer.playerIds.split(",");
      setFavPlayerIds([...arrPlayer]);
    }
  }, [favPlayer]);

  const InsUpFavPlayers = () => {
    //  setLoading(true);
    try {
      PlayerProfileService.insUpFavPlayers({
        EventId: "" + eventId,
        UserName: user.loginID,
        PlayerIds:
          favPlayerIds && favPlayerIds.length ? favPlayerIds.join(",") : "",
        Id: favPlayer.id ? favPlayer.id : 0,
      }).then((response) => {
        setLoading(false);
      });
    } catch {
      setLoading(false);
    }
  };

  const editPlayerProfile = (e, playerInfo) => {
    e.stopPropagation();
    navigate(
      `/${eventId}${RouteConstants.EDIT_PLAYER_PROFILE}/${playerInfo.playerID}`,
      {
        state: { playerID: playerInfo.playerID },
      }
    );
  };

  const viewPlayerProfile = (playerInfo) => {
    navigate(
      `/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerInfo.playerID}`
    );
  };

  const searchPlayerOrCollegeName = (searchValue) => {
    setPlayerNameSearchText(searchValue);
    if (searchValue) {
      let elements = document.getElementsByClassName("selected");
      if (elements.length) {
        elements[0].classList.remove("selected");
      }
      const tempData = [...gridData];
      const updatedPlayerData = tempData.filter((elem) => {
        return (
          elem.playerName
            .toLowerCase()
            .includes(searchValue.toLowerCase().trim()) ||
          elem.collegeOrClub
            .toLowerCase()
            .includes(searchValue.toLowerCase().trim())
        );
      });
      setPlayerData(updatedPlayerData);
    } else {
      setPlayerData(gridData);
    }
  };

  const changeFavPlayer = (e, playerInfo, isFav) => {
    // debugger;
    let favPlayers = favPlayerIds;
    if (isFav == 0) {
      var index = favPlayers.indexOf(playerInfo.playerID);
      var index1 = favPlayers.indexOf("" + playerInfo.playerID);
      if (index == -1 && index1 == -1) {
        favPlayers.push(playerInfo.playerID);
      } else {
        let ind = index > -1 ? index : index1;
        favPlayers.splice(ind, 1);
      }
    } else {
      favPlayers.push(playerInfo.playerID);
    }
    //console.log("favPlayers: ", favPlayers);
    setFavPlayerIds([...favPlayers]);
    InsUpFavPlayers();
  };

  const searchPlayerInitialsByAlphabet = (searchValue, e = null) => {
    let elements = document.getElementsByClassName("selected");
    if (elements.length) {
      elements[0].classList.remove("selected");
    }
    if (searchValue) {
      setPlayerNameSearchText("");
      e.target.classList.add("selected");
      const tempData = [...gridData];
      const updatedPlayerData = tempData.filter((elem) => {
        let playerNameArray = elem.playerName.split(",");
        return (
          playerNameArray[1].charAt(0).toLowerCase() ===
            searchValue.toLowerCase().trim() ||
          playerNameArray[0].charAt(0).toLowerCase() ===
            searchValue.toLowerCase().trim()
        );
      });
      setPlayerData(updatedPlayerData);
    } else {
      setPlayerData(gridData);
    }
  };

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const handleClosePlayerDialog = () => {
    //#Rest dialog form
    resetEntity();

    //#Close state change
    setOpenAddPlayerModal(false);
  };

  const validateForm = () => {
    let isFormValid = false;

    if (playerFName && playerLName && playerCollgeOrClub) {
      isFormValid = true;
    } else {
      setAlert(true);
      setAlertType("warning");
      setAlertMessage("All input fields are mandatory");
    }

    if (playerFName) {
      setEventFNameError(false);
    } else {
      setEventFNameError(true);
    }
    if (playerLName) {
      setEventLNameError(false);
    } else {
      setEventLNameError(true);
    }
    if (playerCollgeOrClub) {
      setEventCollgeOrClubError(false);
    } else {
      setEventCollgeOrClubError(true);
    }
    return isFormValid;
  };

  const resetEntity = () => {
    setPlayerFName("");
    setPlayerLName("");
    setPlayeCollgeOrClub("");
    setEventFNameError(false);
    setEventLNameError(false);
    setEventCollgeOrClubError(false);
  };

  const handleAddPlayer = () => {
    const isFormValid = validateForm();

    if (isFormValid) {
      const formObj = {
        id: 0,
        EventId: eventId,
        FirstName: playerFName,
        LastName: playerLName,
        CollegeOrClub: playerCollgeOrClub,
        UserBy: user.loginID,
      };

      try {
        PlayerProfileService.insertPlayerDetails(formObj).then((result) => {
          if (result?.data?.status === "success") {
            //#Show alert for success
            setAlert(true);
            setAlertType("success");
            setAlertMessage("Player added successfuly.");

            //#Rest dialog form
            resetEntity();

            //#get latest player list update into state.
            getPlayerData();
          } else {
            //#Show alert for error
            setAlert(true);
            setAlertType("error");
            setAlertMessage(result.data.message);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleExportPlayerCheckboxChange = (playerDetails) => {
    const isPlayerExist = exportPlayersDetails.some(
      (player) => player.playerID === playerDetails.playerID
    );

    setExportPlayersDetails(
      isPlayerExist
        ? exportPlayersDetails.filter(
            (player) => player.playerID !== playerDetails.playerID
          )
        : [...exportPlayersDetails, playerDetails]
    );
  };

  const handleExportPlayerSelectAll = () => {
    setExportPlayersDetails(
      exportPlayersDetails.length === playerData.length ? [] : playerData
    );
  };

  const handleExportPlayerDetails = async () => {
    if (exportPlayersDetails.length === 0) {
      showAlert(
        true,
        "warning",
        "Please choose the players you want to export."
      );
      return false;
    }
    try {
      const excelData = await prepareExcelData();
      if (excelData.length === 0) {
        showAlert(true, "error", "No data available for export.");
        return false;
      }
      await downloadExcel(excelData);
      setExportPlayersDetails([]);
    } catch (error) {
      console.error("Error:", error);
      showAlert(true, "error", "Error while exporting the excel file.");
    }
  };

  async function downloadExcel(data) {
    try {
      setOverlayLoading(true);
      const url = APIURLConstants.GET_PLAYER_DETAILS_EXCEL_RESULT();
      const queryParams = { EventId: eventId, userBy: user?.userName };
      const token = sessionStorage.getItem("accessToken").replace(/\"/g, "");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.post(url, data, {
        params: queryParams,
        responseType: "blob",
        headers: headers,
      });
      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1].split(";")[0]
        : "exported-file.xlsx";
      FileSaver.saveAs(response.data, fileName);
    } catch (error) {
      console.error("Error:", error);
      showAlert(true, "error", "Error while exporting the excel file.");
    } finally {
      setOverlayLoading(false);
    }
  }

  const prepareExcelData = async () => {
    return exportPlayersDetails.map((player) => ({
      playerID: player.playerID,
      firstName: player.firstName,
      lastName: player.lastName,
      playerName: player.playerName,
    }));
  };

  //... Utility to show alert.
  const showAlert = (error, type, message) => {
    setAlert(error);
    setAlertType(type);
    setAlertMessage(message);
  };

  return (
    <>
      <Loader isLoading={overlayLoading} />
      <AppBar position="static" className={classes.appbarBackground}>
        <Toolbar className={classes.headerGridContainerStyle}>
          <Grid container spacing={2}>
            <Grid item lg={1.2} md={1.2} sm={2} xs={12}>
              <Typography noWrap variant="h6">
                Player List
              </Typography>
            </Grid>
            <Grid item lg={2.5} md={2.5} sm={12} xs={12}>
              <Box>
                <FormControl fullWidth>
                  <TextField
                    size="small"
                    label={
                      <Typography
                        component="p"
                        variant="body2"
                        noWrap
                        className={classes.searchTextWidth}
                      >
                        Search Player or College Name
                      </Typography>
                    }
                    value={playerNameSearchText || ""}
                    onChange={(e) => searchPlayerOrCollegeName(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {playerNameSearchText !== "" && (
                            <IconButton
                              id="clear-search"
                              aria-label="Clear Search"
                              onClick={(e) => searchPlayerOrCollegeName("")}
                              edge="end"
                            >
                              <ClearIcon color="secondary" />
                            </IconButton>
                          )}
                          <IconButton aria-label="Search" edge="end">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>
            <Grid item lg={5.3} md={5.3} sm={12} xs={12}>
              <Box
                sx={{
                  padding: "3px 0px 0px 8px",
                  overflowWrap: "break-word",
                }}
              >
                {alphabets.map((alphabet, index) => {
                  return (
                    <Typography
                      id=""
                      component="span"
                      className={classes.alphabetStyle}
                      onClick={(e) =>
                        searchPlayerInitialsByAlphabet(alphabet, e)
                      }
                      key={index}
                    >
                      {alphabet}
                    </Typography>
                  );
                })}
                <IconButton
                  aria-label="Clear Search"
                  sx={{ marginLeft: "5px" }}
                  onClick={(e) => searchPlayerInitialsByAlphabet("", e)}
                  title="Clear Search"
                >
                  <RestartAltIcon size="small" color="secondary" />
                </IconButton>
              </Box>
            </Grid>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Button
                  size="small"
                  className={classes.exportToExcel}
                  variant="outlined"
                  sx={{ width: "230px" }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Box
                      onClick={handleExportPlayerDetails}
                      sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                      <TitleTooltip title="Export to Excel" placement="left">
                        <img
                          alt="Excel Icon"
                          src="../../../../playerProfile/excel.png"
                          width="20"
                          height="20"
                        />
                      </TitleTooltip>
                      <span>Export All Players?</span>
                    </Box>

                    <TitleTooltip title="Export All Players" placement="right">
                      <Checkbox
                        checked={
                          exportPlayersDetails?.length === playerData?.length ||
                          false
                        }
                        onChange={handleExportPlayerSelectAll}
                        size="small"
                        color="primary"
                      />
                    </TitleTooltip>
                  </Stack>
                </Button>

                {user.isAdmin && (
                  <TitleTooltip title="Add New Player" placement="bottom">
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={() => setOpenAddPlayerModal(true)}
                      sx={{
                        width: "150px",
                        padding: "10px",
                        backgroundColor: "#1d428a",
                        color: "white",
                        border: "1px solid #1d428a",
                        "&:hover": {
                          backgroundColor: "#16356f",
                        },
                      }}
                    >
                      Add Player
                    </Button>
                  </TitleTooltip>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box display="flex" sx={{ padding: "10px" }}>
        <Grid container spacing={1} columns={12} sx={{ display: "flex" }}>
          {playerData.map((elem, i) => (
            <Grid key={i} item lg={2} md={3} sm={4} xs={12}>
              <div style={{ cursor: "pointer" }}>
                <Card elevation={3}>
                  <TitleTooltip title="Export" placement="top">
                    <Checkbox
                      size="small"
                      inputProps={{
                        "aria-label": "controlled",
                      }}
                      checked={exportPlayersDetails.some(
                        (player) => player.playerID === elem.playerID
                      )}
                      className={classes.playerCardHeaderCheckBox}
                      onChange={() => handleExportPlayerCheckboxChange(elem)}
                    />
                  </TitleTooltip>

                  <CardHeader
                    avatar={
                      <TitleTooltip title="View Profile" placement="bottom">
                        <Avatar
                          sx={{ bgcolor: "#1d428a" }}
                          src={
                            elem.headshotURL ? baseUrl(elem.headshotURL) : ""
                          }
                          alt="basketball"
                          onClick={(e) => {
                            viewPlayerProfile(elem);
                          }}
                        >
                          {elem.playerName.split(",")[0][0]}
                          {elem.playerName.split(",")[1][0]}
                        </Avatar>
                      </TitleTooltip>
                    }
                    action={
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-between"
                      >
                        <Box title="Fav Player">
                          {(favPlayerIds &&
                            favPlayerIds.length > 0 &&
                            favPlayerIds.includes("" + elem.playerID)) ||
                          favPlayerIds.includes(elem.playerID) ? (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                changeFavPlayer(e, elem, 0);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <StarIcon className={classes.startFill} />
                            </IconButton>
                          ) : (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                changeFavPlayer(e, elem, 1);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <StarBorderIcon className={classes.actionIcon} />
                            </IconButton>
                          )}
                        </Box>
                        {RoutePermissions.IsAuthorized(
                          RouteScreens.PlayerProfileEdit,
                          userAppRoles
                        ) ? (
                          <Box title="Edit Profile">
                            <IconButton size="small">
                              <EditIcon
                                className={classes.actionIcon}
                                onClick={(e) => {
                                  editPlayerProfile(e, elem);
                                }}
                              />
                            </IconButton>
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    }
                    title={
                      <Typography
                        noWrap
                        variant="subtitle2"
                        component="p"
                        // className={classes.cardTextWidth}
                        onClick={(e) => {
                          viewPlayerProfile(elem);
                        }}
                      >
                        {elem.playerName}
                      </Typography>
                    }
                    subheader={
                      <>
                        <Typography
                          noWrap
                          variant="caption"
                          component="p"
                          // className={classes.cardTextWidth}
                          onClick={(e) => {
                            viewPlayerProfile(elem);
                          }}
                        >
                          {elem.collegeOrClub}
                        </Typography>
                      </>
                    }
                    sx={{
                      padding: "0px 16px 16px 16px",
                    }}
                  />
                </Card>
              </div>
            </Grid>
          ))}
          {loading && (
            <Box sx={{ marginTop: "30vh", marginLeft: "50%" }}>
              <CircularProgress />
            </Box>
          )}
        </Grid>

        <Dialog
          open={openAddPlayerModal}
          onClose={handleClosePlayerDialog}
          fullWidth="true"
        >
          <DialogTitle sx={{ color: "#1d428a", backgroundColor: "#fff" }}>
            Player Details
          </DialogTitle>
          <Divider sx={{ backgroundColor: "#1d428a" }} />
          <DialogContent>
            <FormControl size="small" fullWidth>
              <TextField
                label="First Name"
                placeholder="Please enter a First Name"
                type="text"
                size="small"
                margin="dense"
                value={playerFName}
                onChange={(e) => setPlayerFName(e.target.value)}
                error={eventFNameError}
              />
            </FormControl>
            <FormControl size="small" fullWidth>
              <TextField
                label="Last Name"
                placeholder="Please enter a last name"
                type="text"
                size="small"
                margin="dense"
                value={playerLName}
                onChange={(e) => setPlayerLName(e.target.value)}
                error={eventLNameError}
              />
            </FormControl>
            <FormControl size="small" fullWidth>
              <TextField
                label="College/Club"
                placeholder="Please enter a College/Club"
                type="text"
                size="small"
                margin="dense"
                value={playerCollgeOrClub}
                onChange={(e) => setPlayeCollgeOrClub(e.target.value)}
                error={eventCollgeOrClubError}
              />
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClosePlayerDialog}>Cancel</Button>
            <Button onClick={handleAddPlayer}>Save</Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={alert}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={3000}
          onClose={handleAlertClose}
        >
          <Alert
            onClose={handleAlertClose}
            severity={alertType}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );
}
